module.exports = __webpack_public_path__ + "static/home/img/2.c94915e2.png";